import React from 'react';

import appSettings from '../../config/settings';
import { FormattedMessage, useIntl } from '../../util/reactIntl';

import { LayoutSingleColumn } from '../../components';
import css from './MaintenanceMode.module.css';

// MaintenanceMode is shown when mandatory app-wide configurations are missing.
// LandingPage/FallbackPage uses the same translated messages when its asset cannot load.
const MaintenanceMode = props => {
  const isDev = appSettings.dev;
  const intl = useIntl();
  return (
    <LayoutSingleColumn
      mainColumnClassName={css.layoutWrapperMain}
      topbar={
        <div
          className={css.header}
          title={intl.formatMessage({ id: 'MaintenanceMode.title' })}
        />
      }
      footer={null}
    >
      <section id="content" className={css.root}>
        <div className={css.content}>
          <h2>
            <FormattedMessage id="MaintenanceMode.title" defaultMessage="Maintenance mode" />
          </h2>
          <p>
            <FormattedMessage
              id="MaintenanceMode.info"
              defaultMessage="The marketplace is not fully operational at the moment."
            />
          </p>
          {isDev ? (
            <>
              <p>
                <FormattedMessage id="MaintenanceMode.devCheckConfig" />
              </p>
              <p>
                <FormattedMessage id="MaintenanceMode.devCheckConsole" />
              </p>
            </>
          ) : (
            <p>
              <FormattedMessage
                id="MaintenanceMode.howToProceed"
                defaultMessage="Try refreshing the page and if that does not solve the issue, contact the marketplace admins."
              />
            </p>
          )}
        </div>
      </section>
    </LayoutSingleColumn>
  );
};

export default MaintenanceMode;
